var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "What We Do",
      "tabActive": "Information Security Management",
      "bg": "/images/sub/visual/sv4.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "page-tit-wrap"
  }, [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Information "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Security Management ")]), _c('p', [_vm._v(" 고객의 데이터를 안전하게 보호하기 위해 전 직원 문서 보안 프로그램을 사용하고 있으며, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" ISO 27001 : 2013 정보보호 관리체계 인증 획득 및 보안관리 절차를 적용하여 데이터 및 시스템 자산을 보호 중 ")])])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "문서 중앙화"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": "/images/sub/wwd/information/info-img1.png",
      "max-width": "950"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "보안 문서 등급화 "
    }
  }, [_c('p', {
    staticClass: "page-text dot-txt color-grey-2c mb-8 mb-lg-14"
  }, [_vm._v(" 폴더별 보안 "), _c('strong', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("등급 부여")]), _vm._v(" 하여 운영중 ")]), _c('div', {
    staticClass: "w-100 border pa-20 pa-md-30 pt-lg-38 pb-lg-60 mb-18 mb-lg-34"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": "/images/sub/wwd/information/info-img2.png",
      "max-width": "709"
    }
  })], 1), _c('p', {
    staticClass: "page-text dot-txt color-grey-2c mb-8 mb-lg-14"
  }, [_vm._v(" 정보자산 중요도 ")]), _c('table', {
    staticClass: "client-table w-100"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "11%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "11%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "11%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "47%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("구분")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("보안 레벨")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("value")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("평가 값 범위")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("내용")])])])]), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("정보자산 중요도")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("1")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("1")])]), _c('td', [_c('div', {
    staticClass: "table-inner color-point font-weight-bold"
  }, [_vm._v("8~9점")])]), _c('td', [_c('div', {
    staticClass: "table-inner left px-xl-40"
  }, [_vm._v("비즈니스 수행에 필요한 핵심자산")])])]), _c('tr', [_c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2")])]), _c('td', [_c('div', {
    staticClass: "table-inner color-point font-weight-bold"
  }, [_vm._v("5~7점")])]), _c('td', [_c('div', {
    staticClass: "table-inner left px-xl-40"
  }, [_vm._v("비즈니스 수행에 영향을 주는 주요자산")])])]), _c('tr', [_c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3")])]), _c('td', [_c('div', {
    staticClass: "table-inner color-point font-weight-bold"
  }, [_vm._v("3~4점")])]), _c('td', [_c('div', {
    staticClass: "table-inner left px-xl-40"
  }, [_vm._v("핵심자산과 주요자산을 지원하는 일반자산")])])])])])])], 1)], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "보안 프로그램 적용된 PC"
    }
  }, [_c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon1.png",
      "iconWidth": "48"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" 파일 반출 전송 결제 시스템으로 결재된 파일에 한해 내외부 협업 지원 ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" 사용자 PC에 문서를 남기지 않아 랜섬웨어 감염을 미연에 방지 ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon2.png",
      "iconWidth": "50"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" 외장하드, USB, CD, 화면캡쳐,프린트 제어, 공유폴더 제어, 첨부파일 제어, 복사/붙여넣기 차단, 원격프로그램 접속 제어 ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" IP 정책을 통한 내/외부 파일 접근 제어 ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon3.png",
      "iconWidth": "48"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" 파일 반출 전송 결제 시스템으로 결재된 파일에 한해 내외부 협업 지원 ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" 1단계 결재, 사전/사후 결재, 다단계, 참조 등 결재라인 저장 ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon4.png",
      "iconWidth": "50"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" 중앙서버 스토리지 내 파일 암호화, 개인정보 암호화를 통한 기업 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 문서자산 보호 ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" 실시간 백신 검사를 통한 바이러스 치료 및 제거 ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon5.png",
      "iconWidth": "54"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" 별도 로컬 내 영역을 지정하여 대용량 파일 저장 및 속도 이슈 방지 ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" 보안드라이브 영역 내 파일 백업 및 용량 설정 지원 ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon6.png",
      "iconWidth": "52"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" 제목, 본문 내 삽입된 개인정보 및 기업 정책에 의해 설정된 특정 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 보안 키워드 검출 ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" 검출 시 해당 문서를 격리 보관하여 외부로의 유출 차단, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 파일 격리 알람 기능 ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" 개인정보보호 컴플라이언스에 대응가능 ")])])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }